import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const ratioPersonalAddonEntity: Entity = {
  model: model,
  repository: repository,
}

export default ratioPersonalAddonEntity
